import type { NodeViewProps, ProseMirrorAttribute } from "ls/common/tiptap-shims";
import type { UniqueIDAttribute, UniqueIDAttributes } from "../extensions/UniqueId";

export interface CalloutItemOptions {

}

export type CalloutItemAttributes = UniqueIDAttributes & {
  icon: string;
  color: string;
};

export const CalloutItemNodeName = "callout";
export type CalloutItemAttributeSpec = Record<keyof CalloutItemAttributes, ProseMirrorAttribute>;
export type CalloutItemAttributeSpecSelf = Omit<CalloutItemAttributeSpec, UniqueIDAttribute>;
export type CalloutItemNodeViewProps = NodeViewProps<CalloutItemOptions, CalloutItemAttributes>;
